<template>
  <div class="mit-manage-maps-page mit-page">

      <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12" class="d-flex">
          <v-card class="mit-info-card">
            <v-card-title>Manage Maps</v-card-title>
            <v-card-subtitle class="caption">Edit spaces and objects on a buildings map.</v-card-subtitle>
            <v-divider></v-divider>

            <v-card-text>
                <v-row no-gutters>
                    <v-card class="mr-5" width="300" link :to="'/manage/maps/'+building" v-for="(building, i) in buildings" :key="i">
                      <v-card-title><v-icon class="pr-3">mdi-office-building-marker-outline</v-icon>Building {{building}}</v-card-title>
                      <v-card-subtitle class="caption">Manage this buildings map.</v-card-subtitle>
                  </v-card>
              </v-row>

            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import MitSpacesService from '../../services/MitSpacesService.js';
  export default {
      name: 'MitManageMapsPage',
      components: {
      },
      data: function() {
          return {
              buildings:[]
          }
      },
      created() {
            //get current settings
            MitSpacesService.getBuildingsMitIdUniqueList()
            .then((buildings) => {
                this.loadingBuildings = false;
                this.buildings = buildings;
                //select the first one by default
                if(this.buildings.length > 0){
                    this.selectedBuilding = 0;
                    this.selectBuilding();
                }
            })
            .catch((error)=>{
                this.loadingBuildings = false;
            });
      }
  }
</script>

<style lang="scss" scoped>
  .mit-info-card {
    width:100%;
    height:100%;
  }
</style>
